import React from 'react';
import Link from 'next/link';
import { TBtnThemeType } from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import * as ST from './styled';

interface IBannerInfo {
    tab_title?: string,
    title?: string,
    tab_text?: string,
    link?: string,
    size?: string,
    image_background?: string,
    image_background_mobile?: string,
    image?: string,
    image_position?: string,
    image_mobile?: string,
    text_color?: string,
    subTitle?: string,
    text?: string,
    button_text?: string,
    phone_introduction?: number
}

interface ILink {
    as?: string,
    href?: string
}


interface IBannerProps {
    onClickHandler: () => void,
    titleButton?: string,
    image?: string,
    imageHeight?: string,
    title?: string,
    description?: string,
    background?: string,
    textColor?: string,
    typeButton?: string,
    dataTestForButton?: string,
    backgroundColor?: string,
    marginTop?: string,
    marginBottom?: string,
    marginRight?: string,
    banner: IBannerInfo,
    subTitle?: string,
    adaptive?: boolean,
    fixedHeight?: boolean,
    routeLink?: ILink,
    customStyles?: Record <string, any>,
    onInputChange?: () => void,
    onClickConnect?: () => void,
    beforeClick?: (bannerIdx: string | undefined) => void,
    bannerIdx?: string,
    [key: string]: any
}

 const Banner = ({ onClickHandler,
    titleButton,
    image,
    imageHeight,
    title,
    description,
    background,
    textColor,
    typeButton = 'primary',
    dataTestForButton,
    backgroundColor,
    marginTop,
    marginBottom,
    marginRight,
    banner = {},
    subTitle = '',
    adaptive = true,
    fixedHeight = false,
    routeLink = {},
    customStyles,
    onInputChange = () => ({}),
    onClickConnect = () => ({}),
    beforeClick = () => ({}),
    bannerIdx,
    ...props }: IBannerProps): JSX.Element => {

        const size = banner.size;
        const bgImage = background || banner.image_background;
        const bgImageMobile = banner.image_background_mobile;
        const frontImage = image || banner.image;
        const frontImagePosition = banner.image_position;
        const frontImageMobile = banner.image_mobile;
        const txtColor = textColor || banner.text_color;
        const titleText = title || banner.title;
        const subTitleText = subTitle || banner.subTitle;
        const descriptionText = description || banner.text;
        const buttonText = titleButton || banner.button_text;
        const phoneIntroduction = banner.phone_introduction ? banner.phone_introduction : 0;

        const extStyles = {
            content: {
                default: {
                    padding: phoneIntroduction ? '10 0 30px 30px' : '70px 0 70px 35px',
                },
                desktop: {
                    padding: phoneIntroduction ? '10 0 30px 30px' : '60px 0 70px 35px',
                },
                xsDesktop: {
                    width: phoneIntroduction ? '550px' : '500px',
                    'padding-top': phoneIntroduction ? '20px' : '60px'
                }
            },
            title: {
                desktop: {
                    'margin-bottom': phoneIntroduction ? '10px' : '15px',
                },
            },
            phoneBlock: {
                input: {
                    'color': txtColor ? txtColor : COLORS.black,
                    '&:focus': {
                        'border-color': txtColor ? txtColor : COLORS.black,
                    }
                },
                span: {
                    'color': txtColor ? txtColor : COLORS.black,
                },
                detailsLink: {
                    'color': txtColor ? txtColor : COLORS.black,
                    'border-bottom': `1px solid ${txtColor ? txtColor : COLORS.black}`,
                },
                offer: {
                    'color': txtColor ? txtColor : COLORS.black,
                },
            },
        };
        return (
            <ST.Wrapper
                backgroundColor={backgroundColor}
                background={bgImage}
                backgroundMobile={bgImageMobile}
                marginTop={marginTop}
                marginBottom={marginBottom}
                fixedHeight={fixedHeight}
                customStyles={customStyles?.wrapper}
                adaptive={adaptive}
                {...props}
                itemScope
                itemType='http://schema.org/ImageObject'
            >
                <ST.Content adaptive={adaptive} size={size} customStyles={customStyles?.content}  extStyles={extStyles?.content}>
                    {subTitleText && <ST.SubTitle>{subTitleText}</ST.SubTitle>}
                    <ST.Title
                        textColor={txtColor}
                        itemProp='name'
                        // @ts-ignore
                        dangerouslySetInnerHTML={{ __html: titleText }}
                        extStyles={extStyles?.title}
                    />
                    {descriptionText && (
                        <ST.Description
                            textColor={txtColor}
                            itemProp='description'
                            dangerouslySetInnerHTML={{ __html: descriptionText }}
                        />
                    )}
                    {
                        phoneIntroduction
                        ? <ST.PhoneBlock>
                            <ST.InputPhone extStyles={extStyles?.phoneBlock}
                                textColor={txtColor}
                                onChange={onInputChange}
                                placeholder='Номер телефона'
                                errorMessage='Укажите корректный номер телефона'
                            />

                            <ST.ConnectButton
                                data-test={dataTestForButton}
                                type={typeButton as TBtnThemeType}
                                text={'Подключить'}
                                onClick={onClickConnect}
                            />
                            {banner.link &&
                                <ST.DetailsLink
                                    href={banner.link}
                                    extStyles={extStyles?.phoneBlock}
                                    target='_blank'
                                    rel='nofollow noopener'
                                    onClick={() => beforeClick(bannerIdx)}>
                                    Подробнее
                                </ST.DetailsLink>
                            }
                            <ST.FootNote extStyles={extStyles?.phoneBlock}>Нажимая кнопку, вы даёте согласение на обработку&nbsp;
                                <ST.OfferLinkWrapper>
                                    <ST.OfferLink extStyles={extStyles?.phoneBlock} href='https://dom.ru/policy.pdf' target='_blank' rel='nofollow noopener'>персональных данных</ST.OfferLink>
                                </ST.OfferLinkWrapper>
                            </ST.FootNote>
                        </ST.PhoneBlock>
                        : null
                    }
                    {
                        (buttonText && !phoneIntroduction) &&
                        <ST.ButtonBlock>
                            {
                                typeButton === 'text'
                                    ? <Link as={routeLink?.as} href={routeLink?.href || ''}>
                                        <ST.TextButton dangerouslySetInnerHTML={{ __html: buttonText }}/>
                                    </Link>
                                    : <ST.Button
                                        data-test={dataTestForButton}
                                        type={typeButton as TBtnThemeType}
                                        onClick={onClickHandler}
                                    >
                                        <span dangerouslySetInnerHTML={{ __html: buttonText }} />
                                    </ST.Button>
                            }
                        </ST.ButtonBlock>
                    }
                </ST.Content>
                <ST.Images adaptive={adaptive} position={frontImagePosition} marginRight={marginRight}>
                    <ST.FrontImageDesktop
                        src={frontImage}
                        imageHeight={imageHeight}
                        hasMobileImage={!!frontImageMobile}
                        alt='' itemProp='contentUrl'
                        adaptive={adaptive}
                    />
                    {
                        frontImageMobile &&
                        <ST.FrontImageMobile src={frontImageMobile} alt='' itemProp='contentUrl' adaptive={adaptive}/>
                    }
                </ST.Images>
            </ST.Wrapper>
        );
};

export default Banner;
